const isLang = /^(lang-)?[a-z]{2}(_[a-z]{2})?\/?$/i;

export default isLang;
